import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { formatName } from '../../helpers'
import * as actions from '../../actions'

class Players extends Component {
  constructor (props) {
    super(props)

    this.state = {
      search: ''
    }

    this.invitePlayer = this.invitePlayer.bind(this)
  }

  invitePlayer (id) {
    this.props.dispatch(actions.switchInvitePlayer({ id }))
  }

  render () {
    let { players } = this.props
    players = players.filter(p => p.name.toLowerCase().includes(this.state.search.toLocaleLowerCase()))

    return (
      <div className='main-col-cell'>
        <div className='dashboard-players'>
          <div className='headline'>
            <h4>Players</h4>
            <div className='search-container'>
              <input
                type='text'
                className='search-input'
                placeholder='search by name'
                value={this.state.search}
                onChange={ev => this.setState({ search: ev.target.value })} />
            </div>
            <div className='players-header'>
              <div className='cell-name'>Name</div>
              <div className='cell-skills'>Skills</div>
              <div className='cell-team'>Team</div>
            </div>
          </div>
          <div className='y-scroll-wrap'>
            <div className='y-scroll'>
              <div className='dashboard-players-list'>
                {players && players.map(player => (
                  <div key={player.id} className='dashboard-players-row' >
                    <div className='cell-name'
                      style={{ background: `url(${player.avatar || '/imgs/default-avatar.png'}) no-repeat center /cover` }} />
                    <div className='cell-subject'>
                      <Link to={`/player/${player.id}`} className='color-inherit'>
                        {formatName(player.name)}
                      </Link>
                    </div>
                    <div className='cell-skills'>
                      {player.my_skills && (
                        player.my_skills.length > 20 ? player.my_skills.slice(0, 20) + '...' : player.my_skills
                      )}
                    </div>
                    <div className='cell-team'>
                      {player.team
                        ? ((this.props.teams.length > 0 && this.props.teams.find(t => t.id === player.team)) && (
                          this.props.teams.find(t => t.id === player.team).name.length > 10
                            ? this.props.teams.find(t => t.id === player.team).name.slice(0, 10) + '...'
                            : this.props.teams.find(t => t.id === player.team).name
                        ))
                        : (
                          <button
                            className='button button-sm'
                            onClick={() => this.invitePlayer(player.id)}>Invite</button>
                        )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    players: state.participants,
    teams: state.team.teams,
    isAuthenticated: state.auth.isAuthenticated
  }
}

export default connect(mapStateToProps)(Players)



// WEBPACK FOOTER //
// ./src/screens/dashboard/Players.js